import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { ClientLogosStrip } from '../components/ClientLogosStrip';
import { FaqSection } from '../components/FaqSection';
import { AchievementsSection } from '../components/AchievementsSection';
import { ServicesSection } from '../components/ServicesSection';
import { NichesSection } from '../components/NichesSection';
import { ProcessSteps } from '../components/ProcessSteps';
import { AdvantagesSection } from '../components/AdvantagesSection';
import { CeoSection } from '../components/CeoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
import { useSEO } from '../hooks/useSEO';
import { useLanguage } from '../context/LanguageContext';
const seoData = {
  UA: {
    title: 'ESCA — Executive Search & Recruiting Agency | Підбір керівників та спеціалістів',
    description: 'ESCA — міжнародна агенція з підбору керівників та спеціалістів. 20+ років досвіду, база 20 000+ кандидатів. Executive Search, IT Recruitment, комплектація команд.',
    keywords: 'executive search, підбір персоналу, рекрутинг, HR агенція, підбір керівників, IT рекрутинг, хедхантинг, Україна, ESCA'
  },
  RU: {
    title: 'ESCA — Executive Search & Recruiting Agency | Подбор руководителей и специалистов',
    description: 'ESCA — международное агентство по подбору руководителей и специалистов. 20+ лет опыта, база 20 000+ кандидатов. Executive Search, IT Recruitment, комплектация команд.',
    keywords: 'executive search, подбор персонала, рекрутинг, HR агентство, подбор руководителей, IT рекрутинг, хедхантинг, Украина, ESCA'
  },
  EN: {
    title: 'ESCA — Executive Search & Recruiting Agency | Top Talent Recruitment',
    description: 'ESCA — international executive search and recruiting agency. 20+ years of experience, 20,000+ candidate database. Executive Search, IT Recruitment, Team Building.',
    keywords: 'executive search, recruitment agency, headhunting, HR agency, IT recruitment, talent acquisition, Ukraine, ESCA'
  }
};
export function LandingPage() {
  const {
    lang
  } = useLanguage();
  const seo = seoData[lang];
  useSEO({
    title: seo.title,
    description: seo.description,
    keywords: seo.keywords,
    ogType: 'website'
  });
  return <div className="min-h-screen w-full bg-white overflow-x-hidden" data-id="element-870" data-mp="3o33sg8yqukso">
      <Header data-id="element-871" data-mp="3j4sizzcd2caz" />
      <main data-id="element-872" data-mp="3j5271hdui9e1">
        <HeroSection data-id="element-873" data-mp="3j5lh6bx97thi" />
        <ClientLogosStrip data-id="element-874" data-mp="3j40vlbsx3kvs" />
        <AchievementsSection data-id="element-875" data-mp="sdv4sijfdmx" />
        <ServicesSection data-id="element-876" data-mp="qkqfirhj3hk" />
        <NichesSection data-id="element-877" data-mp="tyoiet48qj7" />
        <ProcessSteps data-id="element-878" data-mp="3svwxyz21dx5t" />
        <AdvantagesSection data-id="element-879" data-mp="3svesdbthi6l8" />
        <CeoSection data-id="element-880" data-mp="3sw6ocnqzu6c1" />
        <TestimonialsSection data-id="element-881" data-mp="3sy0yr84n2g1v" />
        <FaqSection data-id="element-882" data-mp="apik103rpn7f" />
        <ContactForm data-id="element-883" data-mp="ar3dsni9d248" />
      </main>
      <Footer data-id="element-884" data-mp="anxphahge49k" />
    </div>;
}